import { useQuery } from '@tanstack/react-query'
import { apiFetch, getCallerAgentId, hasLiveApi } from '@/api/client'
import type { AgentNode } from '@/api/map/agent'
import { isUsernameAvailable } from '@/data/api'
import { keys } from '@/api/hooks/shared/keys'

/**
 * Username availability for the Create wizard.
 * Live: names already in the caller's subtree.
 * Demo: fixture world.
 */
async function checkUsername(username: string): Promise<boolean> {
  const needle = username.trim().toLowerCase()
  if (!needle) return false
  if (!hasLiveApi()) return isUsernameAvailable(username)

  const id = getCallerAgentId()!
  const nodes = await apiFetch<AgentNode[]>(`/v1/agents/${id}/tree`)
  return !nodes.some((node) => node.name.trim().toLowerCase() === needle)
}

export function useUsernameAvailable(username: string, enabled: boolean) {
  return useQuery({
    queryKey: keys.usernameAvailable(username),
    queryFn: () => checkUsername(username),
    enabled,
    staleTime: 5_000,
  })
}

/** Imperative check used by the Create page while typing. */
export function checkUsernameAvailable(username: string): Promise<boolean> {
  return checkUsername(username)
}
